export enum FinancialInstitutionEnum {
    Yes = 1,
    No
}
